module.exports = __webpack_public_path__ + "img/damen50_mobile.8c9d8a29.jpg";